import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/WebAccountApi/" );

/* eslint-disable arrow-body-style */

/**
 * Get managed users data.
 */
export const getManagedUsersViewModel = () => {
  return instance.get( "GetManagedUsersViewModel" );
};

/**
 * Update to a manager user account into the given web account.
 * @param {*} webAccountId The web account id.
 * @param {*} updateType The update type.
 * @param {*} updateType The new value.
 */
export const managedUserUpdate = ( webAccountId, updateType, selected ) => {
  return instance.post( "ManagedUserUpdate", null, {
    webAccountId,
    updateType,
    selected
  } );
};

/**
 * Change the active status of a webaccount.
 * @param {*} webAccountId The web account id.
 * @param {*} active The active status.
 */
export const changeWebAccountStatus = ( webAccountId, active ) => {
  return instance.post( "ChangeWebAccountStatus", null, {
    webAccountId,
    active
  } );
};
